import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=d485b8bc&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=d485b8bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d485b8bc",
  null
  
)

export default component.exports